type TProductCategoryBase = {
  /**
   * products belonging to the category
   */
  products: RoA<unknown>
}

/**
 * Returns whether the category has some items (left after filtering) or not.
 */
export const isNotEmptyCategory = (category: TProductCategoryBase) => category.products.length > 0
